export function getStoreFileName(path) {
    var parts = decodeURIComponent(path).split('/');
    return parts[parts.length - 1];
}
export function getStoreFolderPath(path) {
    var parts = decodeURIComponent(path).split('/');
    return parts.splice(0, parts.length - 1).join('/');
}
